import React from "react";

export const AmenitiesDetailsSkeleton: React.FC = () => {
  return (
    <div className="listingSection__wrap animate-pulse">
      {/* Title Section */}
      <div>
        <div className="h-6 w-40 bg-gray-300 rounded-md mb-2"></div>
        <div className="h-4 w-64 bg-gray-200 rounded-md"></div>
      </div>

      {/* Divider */}
      <div className="w-14 border-b border-gray-300 my-4"></div>

      {/* Amenities Icons and Text */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {Array.from({ length: 10 }).map((_, index) => (
          <div key={index} className="flex items-center space-x-3">
            <div className="h-8 w-8 bg-gray-300 rounded-full"></div>
            <div className="h-4 w-2/3 bg-gray-300 rounded-md"></div>
          </div>
        ))}
      </div>

      {/* Divider */}
      <div className="w-14 border-b border-gray-300 my-4"></div>

      {/* View All Amenities Button */}
      <div className="h-10 w-40 bg-gray-300 rounded-md"></div>
    </div>
  );
};

export default AmenitiesDetailsSkeleton;